import {
  SIDE_NAV_LIGHT,
  NAV_TYPE_SIDE,
  DIR_LTR,
} from "constants/ThemeConstant";
import { env } from "./EnvironmentConfig";

export const APP_NAME = "Fintrust";
export const API_BASE_URL = env.API_ENDPOINT_URL;
export const API_LOSS_URL = env.API_ENDPOINT_URL;
export const API_INSURANCE_URL = env.API_ENDPOINT_URL_INSURANCE;
export const API_LMS_URL = env.API_ENDPOINT_URL_LMS;
export const API_BASE_URL_AUTH = env.API_ENDPOINT_AUTH_URL;
export const API_BASE_URL_BRANCH = env.API_ENDPOINT_BRANCH;
export const API_BASE_MOCKUP_URL = env.API_ENDPOINT_MOCKUO_URL;
export const API_COLLATERAL_URL = env.API_ENDPOINT_URL_COLLATERAL;
export const COMPONENTS_PATH = "/components";
export const APP_PREFIX_PATH = "/app";
export const AUTH_PREFIX_PATH = "/auth";
export const REDIRECT_URL_KEY = "redirect";
export const AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/dashboards/default`;
export const UNAUTHENTICATED_ENTRY = "/login";
export const paginationConfig = {
  pageSize: 7,
  pageIndex: 0,
};

export const THEME_CONFIG = {
  navCollapsed: false,
  sideNavTheme: SIDE_NAV_LIGHT,
  sideNavColor: "#fff", // default warna side nav light
  sideNavTextColor: "#222", // default warna teks menu seedbar
  locale: "en",
  navType: NAV_TYPE_SIDE,
  topNavColor: "#3e82f7",
  headerNavColor: "#ffc600",
  mobileNav: false,
  currentTheme: "light",
  direction: DIR_LTR,
  blankLayout: false,
};
